export class PatientRatio {
    id: number;
    costCenterId: number;
    label: string;
    patients: number;
    staffs: number;
}